<template>
  <div>
    <div class="row interaction-section">
      <div class="col-md-6 interaction-main-section">
        <div>
          <img v-if='loaded' :src="programme.image.url" />
        </div>

        <div id="InteractionInformation">
          <div id="InteractionType">
            <h4 v-html="programme.charge"></h4>
          </div>
        </div>
      </div>

      <div class="col-md-6 interaction-content-section">
        <div class='programme-content' v-html="programme.content"></div>

        <p>To book or to learn more, <a href='mailto:education@otagomuseum.nz'>contact</a> the Education team.</p>

        <h5>Curriculum links</h5>

        <ul>
          <li v-for='curriculum in programme.curriculums'>{{curriculum.title}}
          </li>
        </ul>

        <h5>Levels</h5>

        <span class='programme-levels'>{{levels}}</span>
      </div>
    </div>
  </div>
</template>

<style lang='less'>
.programmeClass {
  border: 1px solid black;
  padding: 5px;
  text-align: center;
}

.programme-levels {
  margin-left: 20px;
}

.programme-content {
  margin-bottom: 1em;
}

h5 {
  margin-top: 2em;
}

#InteractionCarousel {
  margin-top: 10px;
  img {
    padding-right: 3px;
  }
}
</style>

<script>
import axios from "axios";
import Vue from "vue";
import { mapState } from 'vuex'

export default {
  name: "education-programme",
  props: ["slug"],
  data() {
    return {
      loaded: false
    };
  },
  computed: {
    ...mapState({
      programme: state => state.currentProgramme
    }),
    levels() {
      return _.map(this.programme.levels, x=>x.title).join(',');
    },
    breadcrumb() {
      return [
        {name: 'educationprogrammes', title: 'programmes' },
        {name: 'educationprogramme', title: this.programme.title, params: { slug: this.slug} }
      ];
    }
  },
  methods: {
    refresh() {
      this.$store.dispatch('loadProgramme', this.slug).then(() => {
        this.loaded = true;
        this.$emit('updateHead', this.programme.title);
      });
      // let query = JSON.stringify({ "id": this.slug });

      // axios.get(`${this.$api}/education/programmes?query=${query}`).then(
      //   (result) => {
      //     this.programme = result.data;

      //     this.$emit('updateHead', this.programme.title);
      //   },
      //   (error) => {
      //     console.log(error);
      //   }
      // );
    },
  },
  created() {
    this.refresh();
  },
};
</script>